<template>
    <div id="map" style="height: 100%; width: 100%; position: absolute"></div>
</template>

<script>
import { useRoute } from 'vue-router';
import MobileDetect from 'mobile-detect';
import productService from '../services/product';
import client from '../client/client';
import fetchLastPosition from '../services/fetchLastPosition'; 

//테스트 url
//geofence?location=41.90730035309574,-87.84194961190224&id=65c03e71821c0b0008673117&device_serial=90349301240027
"/geofence?location=41.90784929772995, -87.83773351460695&id=65dc3154139a75000800fbd3&device_serial=90349301240027&radius_unit=Km"

export default {
    name: 'Geofence',
    data() {
        const { query } = useRoute();
        const md = new MobileDetect(window.navigator.userAgent);
        return {
            map: null,
            query,
            md,
            location: query.location ? query.location.split(",") : [40.684035,-74.0942416],
            radius: query.radius ? parseInt(query.radius) : null,
            radius_unit: query.radius_unit ? query.radius_unit : 'Km',
            type: query.type || 'default',
            geofence_marker: query.mlat ? {lat: parseFloat(query.mlat), lng: parseFloat(query.mlng)} : null,
            mapClickListener: null,
            dragEventListener: null,
            dragEndEventListener: null,
            idleEventListener: null,
            id: query.id ? query.id + "" : null,
            positions: [],
            isRefresh: false,
            svg_code: encodeURIComponent('<svg width="40px" height="40px" viewBox="0 0 40 40" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="app" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="Group-9"><circle id="Oval" fill="#0099A8" cx="20" cy="20" r="20"></circle><g id="directions_car_FILL0_wght400_GRAD0_opsz24" transform="translate(11.000000, 12.000000)" fill="#FFFFFF" fill-rule="nonzero"><path d="M3,14 L3,15 C3,15.2833333 2.90416667,15.5208333 2.7125,15.7125 C2.52083333,15.9041667 2.28333333,16 2,16 L1,16 C0.716666667,16 0.479166667,15.9041667 0.2875,15.7125 C0.0958333333,15.5208333 0,15.2833333 0,15 L0,7 L2.1,1 C2.2,0.7 2.37916667,0.458333333 2.6375,0.275 C2.89583333,0.0916666667 3.18333333,0 3.5,0 L14.5,0 C14.8166667,0 15.1041667,0.0916666667 15.3625,0.275 C15.6208333,0.458333333 15.8,0.7 15.9,1 L18,7 L18,15 C18,15.2833333 17.9041667,15.5208333 17.7125,15.7125 C17.5208333,15.9041667 17.2833333,16 17,16 L16,16 C15.7166667,16 15.4791667,15.9041667 15.2875,15.7125 C15.0958333,15.5208333 15,15.2833333 15,15 L15,14 L3,14 Z M2.8,5 L15.2,5 L14.15,2 L3.85,2 L2.8,5 Z M2.0375,7 L2.0375,12 L2.0375,7 Z M4.5,11 C4.91666667,11 5.27083333,10.8541667 5.5625,10.5625 C5.85416667,10.2708333 6,9.91666667 6,9.5 C6,9.08333333 5.85416667,8.72916667 5.5625,8.4375 C5.27083333,8.14583333 4.91666667,8 4.5,8 C4.08333333,8 3.72916667,8.14583333 3.4375,8.4375 C3.14583333,8.72916667 3,9.08333333 3,9.5 C3,9.91666667 3.14583333,10.2708333 3.4375,10.5625 C3.72916667,10.8541667 4.08333333,11 4.5,11 Z M13.5,11 C13.9166667,11 14.2708333,10.8541667 14.5625,10.5625 C14.8541667,10.2708333 15,9.91666667 15,9.5 C15,9.08333333 14.8541667,8.72916667 14.5625,8.4375 C14.2708333,8.14583333 13.9166667,8 13.5,8 C13.0833333,8 12.7291667,8.14583333 12.4375,8.4375 C12.1458333,8.72916667 12,9.08333333 12,9.5 C12,9.91666667 12.1458333,10.2708333 12.4375,10.5625 C12.7291667,10.8541667 13.0833333,11 13.5,11 Z M2,12 L16,12 L16,7 L2,7 L2,12 Z" id="Shape"></path></g></g></g></svg>')
        };
    },  
    mounted() {
        const route = useRoute();
        const {query} = route;
        client.updateToken(query);
        this.initializeMap();

        this.refreshInterval = setInterval(() => {
            this.refreshData();
        }, 10000);
    },
    beforeDestroy() {
        if (this.refreshInterval) {
            clearInterval(this.refreshInterval);
        }
    },
    created() {
        window.mapView = this;
    },
    methods: {
        async refreshData() {
            this.isRefresh = true;
            const res = await productService.fetchDeviceTrackEventDetail(this.query.device_serial);
            if(res.r && res.track_list && res.track_list.length > 0) {
                this.lastPositionMarker = await fetchLastPosition(res.track_list, this.map, this.lastPositionMarker, this.svg_code);
            }
        },
        
        async initializeMap() {
            if(this.query.device_serial) {
                const res = await productService.fetchDeviceTrackEventDetail(this.query.device_serial);
                if(res.track_list) {
                    res.track_list.map((item) => {
                        if(item.latitude != 0 || item.longitude != 0)
                            this.positions.push(new google.maps.LatLng(item.latitude, item.longitude));
                    });
                    
                }
            }

            if(this.id) {
                const res = await productService.fetchGeofenceDetail(this.id);
                if(res && res.r && res.geofence) {
                    this.radius = res.geofence.radius;
                    this.geofence_marker = res.geofence.marker;
                    this.createMap();
                }
            } else {
                this.createMap();
            }
        },
        async createMap() {
            if (this.location.length !== 2) return;
            const { location, type, radius, geofence_marker } = this;
            const center = new google.maps.LatLng(location[0], location[1]);
            let zoom = this.calculateZoom(radius, this.radius_unit);

            this.map = new google.maps.Map(document.getElementById('map'), {
                zoom,
                center,
                disableDefaultUI: false,
                zoomControl: false,
                mapTypeControl: false,
                scaleControl: false,
                streetViewControl: false,
                rotateControl: false,
                fullscreenControl: false,
            });

            if (geofence_marker) {
                this.updateMarkerAndGeofence(geofence_marker, radius);
            }

            if(this.positions.length > 0) {
                this.updatePolyline();
            }
        },
        updatePolyline() {
            // const polyline = new google.maps.Polyline({
            //     path: this.positions,
            //     geodesic: true,
            //     strokeColor: '#FF0000',
            //     strokeOpacity: 1.0,
            //     strokeWeight: 3,
            //     icons: [{ icon: { path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW } }],
            // });

            // polyline.setMap(this.map);
            const target = this.positions.at(-1);
            if(target && target.lat && target.lng) 
                this.map.setCenter(this.positions.at(-1));

            if (this.lastPositionMarker) {
                this.lastPositionMarker.setMap(null);
            }

            this.lastPositionMarker = new google.maps.Marker({
                position: target,
                map: this.map,
                icon: {
                    url: `data:image/svg+xml;utf8,${this.svg_code}`,
                    scaledSize: new google.maps.Size(40, 40), // SVG 이미지의 크기를 조정합니다.
                    anchor: new google.maps.Point(40, 40), // 마커의 앵커 포인트를 조정합니다. SVG 이미지의 중앙에 위치시킵니다.
                },
            });
        },

        calculateZoom(radius, radius_unit) {
            let zoom;
            if(!radius)
                return 16;

            if(radius_unit == 'Mi')
                radius = radius * 1.60934;

            if (radius <= 1) {
                zoom = 14;
            } else if (radius <= 5) {
                zoom = 13;
            } else if (radius <= 10) {
                zoom = 12;
            } else if(radius <= 30){
                zoom = 11;
            } else {
                zoom = 10;
            }
            return zoom;
        },

        
        updateMarkerAndGeofence(location, radius) {
            this.updateMarker(location);
            if (radius) {
                this.updateGeofence(location, radius);
            }
        },
        updateGeofence(location, radius) {
            if (this.geofence) {
                this.geofence.setMap(null);
                this.geofence = null;
            }
            
            let radiusInMeters;

            if(this.radius_unit == 'Km') {
                radiusInMeters = radius * 500;
            } else {
                radiusInMeters = (radius * 1609.34) / 2;
            }

            const google = window.google;
            this.geofence = new google.maps.Circle({
                map: this.map,
                radius: radiusInMeters,
                fillColor: '#1363FF',
                fillOpacity: 0.2,
                strokeColor: '#1363FF',
                strokeOpacity: 0.5,
                strokeWeight: 2,
                center: location,
                clickable: false,
            });
        },
        updateMarker(location) {
            if (this.marker) {
                this.marker.setMap(null);
            }

            const google = window.google;
            this.marker = new google.maps.Marker({
                position: location,
                map: this.map,
                icon: {
                    path: google.maps.SymbolPath.CIRCLE,
                    scale: 10,
                    fillColor: "#1363FF",
                    fillOpacity: 1,
                    strokeColor: '#fff',
                    strokeOpacity: 1,
                    strokeWeight: 3,
                }
            });
        }
    }
};
</script>